/*
 * Module for the broadcast message control
*/
rs.module("core/ui/controls/broadcastmessage",

    [ "common/perfect-scrollbar" ],

    function (perfectScrollbar) {

        var scrollbars = [];

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, cssClasses, broadcastMessageKeys) {
            
            // unpack js selectors
            var broadcastModalPopup = $.js(jsSelectors.broadcastModalPopup);
            var modalPopupCancelButton = broadcastModalPopup.js(jsSelectors.modalPopupCancelButton);
            var carouselControl = broadcastModalPopup.js(jsSelectors.carouselControl);
            var carouselInner = broadcastModalPopup.js(jsSelectors.carouselInner);
            var indicators = broadcastModalPopup.js(jsSelectors.indicators, { required: false, multiple: true });
            var suppressCheckbox = broadcastModalPopup.js(jsSelectors.suppressCheckbox, { required: false });
            var carouselItemsSizer = $.js(jsSelectors.carouselItemsSizer);

            // Initialize broadcast message control
            var broadcastMessageSet = new Set([broadcastMessageKeys[0]]);

            setupMessages();

            // Show broadcast modal on page load after controls have rendered.
            // Since we are resizing the modal based on the contents, we want to load as late as possible to avoid anything "popping in"
            // The exception is the perfect scrollbar, which we'll still load last
            $(function () {
                broadcastModalPopup.modal("show");
            });
            
            // Hide the Modal popup once Close is clicked
            modalPopupCancelButton.click(function () {
                broadcastModalPopup.modal('hide');

                for (var scrollbar of scrollbars) {
                    scrollbar.destroy();
                }
                scrollbars = [];

                return false;
            });

            // Listen to the carousel slide event.
            carouselControl.on('slide.bs.carousel', function (properties) {

                // Add the active slide's broadcast message key to the set.
                broadcastMessageSet.add(broadcastMessageKeys[properties.to]);

                changeActiveIndicator(properties);
            });

            // Listen for the modal shown event
            broadcastModalPopup.on('shown.bs.modal', function () {

                // Setup perfect scrollbars immediately after modal is shown
                // This is to ensure that they appear correctly on page load, rather than popping in when the user hovers
                setupPerfectScrollbars();

                // Because we setup scrollbars right after the modal is shown, fade them in to avoid a separate unpleasant pop-in
                broadcastModalPopup.find(".ps__rail-y").each(function () {
                    $(this).fadeTo(200, 0.6); // Fades to opacity 0.6
                });
            });

            // Listen for the modal close event
            broadcastModalPopup.on('hide.bs.modal', function () {

                // Submit viewed keys for suppression if checkbox is :checked.
                if (suppressCheckbox && suppressCheckbox.is(":checked")) {

                    // Make AJAX call to send reset request.
                    $.post(
                        backendUrls.suppressBroadcastMessages,
                        { broadcastMessageKeys: [...broadcastMessageSet] }
                    );

                    return;
                }
            });
            
            // Control the activating of the indicators when navigating the carousel
            function changeActiveIndicator(properties) {

                // remove active classes from indicators
                indicators.removeClass(cssClasses.active);

                // add active class to indicator of same index as active slide
                indicators.filter(`[data-slide-to=\"${properties.to}\"]`).addClass(cssClasses.active);
            }

            // Setup perfect scrollbars
            function setupPerfectScrollbars() {

                var scrollContents = broadcastModalPopup.js(jsSelectors.scrollContent, { required: false, multiple: true });

                for (var scrollContent of scrollContents) {
                    scrollbars.push(perfectScrollbar.createInstance(scrollContent,
                        {
                            suppressScrollX: true,
                        }));
                }
            }

            // Move the broadcast messages into the crousel and set their height
            function setupMessages() {

                // Set the heights of the carousel items to the height of the sizer
                carouselItemsSizer.find(".carousel-item").css("height", carouselItemsSizer.height());

                // Copy the carousel items into the carousel
                carouselInner.html(carouselItemsSizer.html());

                // Lose the sizer
                carouselItemsSizer.remove();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);